import { AlertController } from '@ionic/angular';
import { Router,NavigationExtras } from '@angular/router';
import { Storage } from '@ionic/storage';
import { LoaderService } from './../loder_service/loader.service';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {
my_cart:any;
cart_count:any;
cart_grnd_total:any=0
shipping_charge:any=0
total_order_amount:any=0

  constructor(public alertController:AlertController,public router:Router, public storage:Storage,public restApi:DataService,public toastServe:LoaderService) { }

  ngOnInit() {}
  ionViewWillEnter(){
  this.toastServe.showLoader('')
  
   
      let postparam={
        cartsessionId: localStorage.getItem('cart_session'),
        usersessionid: localStorage.getItem('user_id')
      }
       this.restApi.view_cart(postparam).subscribe((data:any)=>{
         this.my_cart=data.cart_item_array;
         this.cart_count=this.my_cart.length
         if(this.cart_count==0){
           this.toastServe.create('Cart is empty!');
           
           localStorage.setItem('cart_count','');
           this.cart_count='';
         }
        
        
         localStorage.setItem('cart_count',this.cart_count);
         this.cart_grnd_total=data.cart_grnd_total;
         this.shipping_charge=data.shipping_charge;
         this.total_order_amount=data.total_order_amount;
         this.toastServe.hideLoader()
       },(error:any)=>{
        this.toastServe.hideLoader()
       })
  

}
incriment(item){
 
  
    
      let postparam={
        cartid:item.cart_id,
        current_stock_qty:item.current_stock_qty,
        usersessionid:localStorage.getItem('user_id')
      }
      this.restApi.item_incriment(postparam).subscribe((data:any)=>{
        if(data==1){
          this.ionViewWillEnter();
        }
        else{
          alert("Order ouantity exceeds!");
        }
        
      },(error:any)=>{

      })

  
  
}
decriment(item){
  console.log(item.cart_id)
  let cart_id=item.cart_id

 
    
    let postparam={
      cartid:cart_id,
      usersessionid:localStorage.getItem('user_id')
    }
    this.restApi.item_decriment(postparam).subscribe((data:any)=>{
      this.ionViewWillEnter();
    },(error:any)=>{

    })

 

}
add_to_wish(item){
 this.toastServe.showLoader('')
  
    if(localStorage.getItem('user_id')){

   
      console.log()
      let postparams={
          productId:item.cart_item_id, 
          usersessionId: localStorage.getItem('user_id')
  }

    console.log(postparams)
    this.restApi.add_to_wish_list(postparams).subscribe((data:any)=>{
      this.toastServe.hideLoader()
      if(data.result==0){
        this.toastServe.create('Item already saved')
      }else if(data.result==1){
        this.toastServe.create('Item saved successfully')
      }
     
    },(error:any)=>{
      this.toastServe.hideLoader()
      this.toastServe.create('Having some issues from server end')
    })
      
    }else{
      console.log('its else part');
      //this.router.navigate[('/signin')]
      this.router.navigateByUrl('/signin')
      this.toastServe.create('Please login...')
      this.toastServe.hideLoader();
    }
 
}
delete_item_from_cart(item){
  this.toastServe.showLoader('');
  console.log('its fire');
  
    let postparams={
        cartid:item.cart_id,
        usersessionid:  localStorage.getItem('user_id')
    }
    console.log(postparams);
    this.restApi.delete_from_cart(postparams).subscribe((data:any)=>{
      this.toastServe.hideLoader()
      this.ionViewWillEnter();
    },(error:any)=>{
      this.toastServe.hideLoader()
    })
  
  
}
checkOut(){
 
    if(localStorage.getItem('user_id')){
     
      console.log('if section');
      let navigationExtras: NavigationExtras = {
        queryParams: {
          total_price: JSON.stringify(this.cart_grnd_total),
          shipping_charge: JSON.stringify(this.shipping_charge),
          total_order_amount: JSON.stringify(this.total_order_amount)
        }
      };
      this.router.navigate(['/checkout'], navigationExtras); 
    }else{
      this.router.navigate(['/signin'])
      console.log('else section');
      
    }
 
}

async ClosingApp(item)
 {
      let alert = await this.alertController.create({
      header: 'Confirm',
      message: "Are you sure you want to remove this item as of now!!!",
      buttons: [{
        text: "OK",
        handler: () => { 
          this.delete_item_from_cart(item)
         }
      }, {
        text: "Cancel",
        role: 'cancelar',
      }]
    })
     alert.present();
 }
}
